/* eslint-disable @typescript-eslint/no-magic-numbers */
import { AbstractControl, ValidationErrors } from '@angular/forms';

const discountCodeRegex = /^[a-zA-Z0-9]{0,12}$/;

const validateDiscountCode = (discountCode: string): boolean => discountCodeRegex.test(discountCode);

const DiscountCodeValidator = (formControl: AbstractControl): ValidationErrors | null => {
  const value = formControl && (formControl.value as string);

  if (!value) {
    return {};
  }
  const discountCode = !validateDiscountCode(value);

  if (!discountCode) {
    return {};
  }

  return { discountCode };
};

export default DiscountCodeValidator;
